
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.917 10.292A5.152 5.152 0 012.77 5.146 5.152 5.152 0 017.917 0a5.152 5.152 0 015.146 5.146 5.152 5.152 0 01-5.146 5.146zm0-8.709a3.567 3.567 0 00-3.563 3.563 3.567 3.567 0 003.563 3.562 3.566 3.566 0 003.562-3.562 3.566 3.566 0 00-3.562-3.563z"}}),_c('path',{attrs:{"d":"M15.042 19a.792.792 0 01-.792-.792 6.341 6.341 0 00-6.333-6.333 6.341 6.341 0 00-6.334 6.333.792.792 0 01-1.583 0c0-4.365 3.552-7.916 7.917-7.916 4.364 0 7.916 3.551 7.916 7.916a.792.792 0 01-.791.792zm3.67-7.125a4.36 4.36 0 01-4.355-4.354 4.36 4.36 0 014.355-4.354 4.36 4.36 0 014.354 4.354 4.36 4.36 0 01-4.354 4.354zm0-7.125a2.774 2.774 0 00-2.771 2.77 2.774 2.774 0 002.77 2.771 2.774 2.774 0 002.771-2.77 2.774 2.774 0 00-2.77-2.771z"}}),_c('path',{attrs:{"d":"M24.541 19a.792.792 0 01-.791-.792c0-.595-.105-1.18-.312-1.74a5.005 5.005 0 00-2.619-2.833 4.999 4.999 0 00-3.855-.153.796.796 0 01-1.017-.469.787.787 0 01.469-1.017 6.593 6.593 0 012.285-.41 6.652 6.652 0 016.221 4.335c.273.735.411 1.504.411 2.287a.793.793 0 01-.792.792z"}})])
          )
        }
      }
    